// extracted by mini-css-extract-plugin
export default {"offlinePopupContainer":"offlinePopup_offlinePopupContainer__-fRRx"};